import { Link } from "react-router-dom"
import { ModalTradesSettings } from "./ModalTradesSettings"
import { useState } from "react"
import { ModalGraphSettings } from "./ModalGraphSettings"

export const ButtonChart = ({ AccountId }: any) => {
    const [visibleTradeSetting, setVisibleTradeSetting] = useState<boolean>(false)
    const [visibleGraphSetting, setVisibleGraphSetting] = useState<boolean>(false)

    return (
        <>
            <div className='w-full flex items-center flex-wrap  mt-3'>
                <button onClick={() => { setVisibleGraphSetting(true) }} className='md:w-[150px] w-full md:mb-0 mb-2 cursor-pointer shadow mr-2 h-[40px] bg-trade-25 rounded-md text-white flex items-center justify-center text-sm'>تنظیمات گراف</button>
                <Link className="md:w-[150px] w-full md:mb-0 mb-2 mr-2" to={`/statement`}>
                    <button className='md:w-[150px] w-full cursor-pointer shadow  h-[40px] bg-trade-25 rounded-md text-white flex items-center justify-center text-sm'> دریافت استیتمنت</button>
                </Link>
                <button onClick={() => { setVisibleTradeSetting(true) }} className='md:w-[150px] w-full  cursor-pointer shadow mr-2 h-[40px] bg-trade-25 rounded-md text-white flex items-center justify-center text-sm'>تنظیمات معاملات</button>
            </div>

            <ModalTradesSettings
                visible={visibleTradeSetting}
                setVisible={setVisibleTradeSetting}
            />

            <ModalGraphSettings
                visible={visibleGraphSetting}
                setVisible={setVisibleGraphSetting}
            />
        </>
    )
}